import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as moment from 'moment';
import ProfileBox from '../components/general/profileBox';
import Spinner from '../components/general/spinner';
import webServices from '../services/webServices';
import { getUserPlansDetails, setUser } from '../redux/actions/user.actions';
import { pageTitle } from '../redux/actions/home.actions';
import NoActivePlanPopup from './noActivePlanPopup';
import WelcomePopup from './welcomePopup';
import Section2remainderPopup from './section2remainderPopup';
import AppConstants from '../appConstants';
import PlanExpireRemainderPopup from './planExpireRemainderPopup';
import HoldMatchPopup from './holdMatchPopup';
import RoseSendPopup from './roseSendPopup';
import DailyLikeRemainderPopup from './dailyLikeRemainderPopup';
import DailyLikeRemainderForRosePopup from './dailyLikeRemainderForRosePopup';
import RoseExceedPopup from './roseExceedPopup';
import FirstMatchPopup from './firstMatchPopup';
import { authCall } from '../services';
import MatchQueueFilterComponent from '../components/general/matchQueueFilter';
import { checkIfMatchQueueFilterApplied, decodeData, encodeData } from '../helpers';
import NoMatchQueueDataComponent from './noMatchQueueDataComponent';

const matchFilterPreferences = AppConstants.MATCH_QUEUE_FILTERS;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MatchesPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { planDetails, current } = useSelector((state) => state.user);
  const [matchData, setMatchData] = useState([]);
  const [matchCount, setMatchCount] = useState(0);
  const [myMatchedCount, setMyMatchedCount] = useState(0);
  const [userData, setUserData] = useState({});
  const [isSpinner, setIsSpinner] = useState(true);
  const [bonusMsg, setBonusMsg] = useState(false);
  const [planExpireRemainder, setPlanExpireRemainder] = useState(false);
  const [dailyLikeRemainder, setDailyLikeRemainder] = useState(false);
  const [dailyLikeRemainderRose, setDailyLikeRemainderRose] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showActivePlan, setShowActivePlan] = useState(false);
  const [showRoseSend, setShowRoseSend] = useState(false);
  const [roseSent, setRoseSent] = useState(false);
  const [roseExceed, setRoseExceed] = useState(false);
  const [roseCountSend, setRoseCountSend] = useState(0);
  const [myTotalRoses, setMyTotalRoses] = useState(0);
  const [section2RemainderMsg, setSection2RemainderMsg] = useState(false);
  const [isOpenHoldMatch, setIsOpenHoldMatch] = useState(true);
  const [isOpenFirstMatchPopup, setIsOpenFirstMatchPopup] = useState(false);
  const [userListingView, setUserListingView] = useState('grid-view');
  const [isFilterPopupVisible, setIsFilterPopupVisible] = useState(false);
  const query = useQuery();
  const pageQueryParam = query.get("q");
  const uidParamRef = useRef({ uid: null, isLoaded: false });
  // Everyone on the "liked me" tab already likes us, so Like there makes a
  // match: take the user to that match on My Matches. When the first-match
  // popup is up, this holds the link until the popup is closed.
  const pendingMatchRedirectRef = useRef(null);

  const getMataches = async () => {
    setLoader(true);
    setIsSpinner(true);

    const matchPreferences = { ...matchFilterPreferences, ...current.match_preferences };
    const resp = await authCall(`user/match-queue-listing${location.search}`, matchPreferences);
    if (resp && resp.success === true) {
      setMatchData(resp.data);
      setUserData(resp.data[0]);

      if (resp.data.length > 0 && uidParamRef.current.uid && uidParamRef.current.isLoaded === false) {
        uidParamRef.current.isLoaded = true;

        const uidIndex = resp.data.findIndex(row => `${row.userId}` === `${uidParamRef.current.uid}`);
        if (uidIndex >= 0) {
          setUserListingView('single-view');
          setMatchCount(uidIndex);
          setUserData(resp.data[uidIndex]);
        }
      }

      setTimeout(() => {
        setLoader(false);
        setIsSpinner(false);
      }, 1000);

      // if (showMatchQueuePreferencePage() && resp.data.length === 0) {
      //   // history.push(AppConstants.routes.matchQueueCountryPreference);
      // }
    }
  };

  const setMatchProfile = async (indexNo) => {
    let userProfileIndex = indexNo;
    const matchDataLength = matchData.length;

    if (userProfileIndex === matchDataLength && matchDataLength > 0) {
      userProfileIndex = matchDataLength - 1;
    }

    const selectedUserData = matchData[userProfileIndex] ?? {};

    if (Object.keys(selectedUserData).length > 0) {
      setMatchCount(userProfileIndex);
      setUserData(selectedUserData);
    } else {
      await getMataches();
    }
  }

  const checkIfUserPlanExpired = () => {
    // `current` is null for anonymous visitors and until the profile request
    // resolves; dereferencing it here used to crash the page.
    if (!current || current.plan_expiry_date === null) {
      return true;
    }

    const currentDate = moment().startOf('day');
    const planExpiryDate = moment(current.plan_expiry_date, 'YYYY-MM-DD');
    const days = Math.floor(moment.duration(planExpiryDate.diff(currentDate)).asDays());

    return days <= 0;
  };
  const isUserPlanExpired = checkIfUserPlanExpired();

  // const showMatchQueuePreferencePage = () => {
  //   const todayDate = moment().format('YYYY-MM-DD');
  //   if (current.show_all_match_queue_users === null || current.show_all_match_queue_date !== todayDate) {
  //     return true;
  //   }
  //   return false;
  // };

  const getMatchCount = async () => {
    const resp = await webServices.getMatchCount();
    if (resp && resp.success === true) {
      setMyMatchedCount(resp.data.count);
      // localStorage.setItem('matchCount', resp.data.count);
    }
  };

  const removeUserFromMatchData = (userId, skipUser = false) => {
    if (!skipUser) {
      const index = matchData.findIndex(user => user.userId === userId);
      if (index !== -1) {
        matchData.splice(index, 1);
        setMatchData(matchData);

        if (matchData.length === 0 && userListingView === 'single-view') {
          setUserListingView('grid-view');
        }
      }
    }

    // Change User Profile
    if (userListingView === 'single-view') {
      const newMatchCount = matchCount + (skipUser ? 1 : 0);
      setMatchProfile(newMatchCount);
    }
  }

  const handleShowActivePlan = () => setShowActivePlan(true);
  const handleCloseActivePlan = () => setShowActivePlan(false);
  const handleCloseBounsMsg = () => setBonusMsg(false);
  const handleCloseHoldMatch = () => setIsOpenHoldMatch(false);
  const handleClosePlanRemainder = () => setPlanExpireRemainder(false);

  const handleCloseCancel = () => {
    setRoseSent(false);
    setShowRoseSend(false);
  };

  const handleCloseRoseSend = () => {
    const userId = matchData[matchCount]?.userId;

    // Remove user from match data
    removeUserFromMatchData(userId);

    setRoseSent(false);
    setShowRoseSend(false);
  };

  const handleCloseDailyLikeRemainder = () => setDailyLikeRemainder(false);
  const handleCloseDailyLikeRemainderRose = () => setDailyLikeRemainderRose(false);
  const handleCloseRoseExceed = () => setRoseExceed(false);
  const handleCloseSection2Remainder = () => setSection2RemainderMsg(false);
  const handleFirstMatchPopupCloseBtn = () => {
    setIsOpenFirstMatchPopup(false);
    const redirectTo = pendingMatchRedirectRef.current;
    pendingMatchRedirectRef.current = null;
    if (redirectTo) {
      history.push(redirectTo);
    }
  };

  const handleLike = async () => {
    const resp = await authCall('user/userCheckPermission', { action: 'like' });
    if (resp.data === 'profileNotApproved') {
      history.push(AppConstants.routes.congratulations);
    } else if (resp.data === 'profileNotComplete') {
      setSection2RemainderMsg(true);
    } else if (resp.data === 'likeAvailable') {
      const uDetails = matchData[matchCount];

      if (uDetails?.userId) {
        // Remove user from match data
        removeUserFromMatchData(uDetails?.userId);

        const apiResponse = await webServices.userLike({ userId: uDetails?.userId, action: 'like' });
        const showFirstMatchPopup = apiResponse?.data?.showFirstMatchPopup === true;
        if (showFirstMatchPopup) {
          setIsOpenFirstMatchPopup(true);
        }
        if (pageQueryParam === 'liked-me' && apiResponse?.data?.profileMatched) {
          const redirectTo = `${AppConstants.routes.matchQueue}?uid=${encodeData(uDetails.userId)}`;
          if (showFirstMatchPopup) {
            pendingMatchRedirectRef.current = redirectTo;
          } else {
            history.push(redirectTo);
          }
        }
      } else {
        setUserData({});
      }

      getMatchCount();
      dispatch(getUserPlansDetails());
    } else if (resp.data === 'showDailyLikeRemainder') {
      setDailyLikeRemainder(true);
    } else if (resp.data === 'noActivePlan') {
      setShowActivePlan(true);
    }
  };

  const handleDislike = async (skipUser = false) => {
    if (skipUser) {
      const uDetails = matchData[matchCount];

      if (uDetails?.userId) {
        // Remove user from match data
        removeUserFromMatchData(uDetails?.userId, true);
      } else {
        setUserData({});
      }
    } else {
      const resp = await authCall('user/userCheckPermission', {
        action: 'dislike'
      });
      if (resp.data === 'profileNotApproved') {
        history.push(AppConstants.routes.congratulations);
      } else if (resp.data === 'profileNotComplete') {
        setSection2RemainderMsg(true);
      } else if (resp.data === 'likeAvailable') {
        const uDetails = matchData[matchCount];

        if (uDetails?.userId) {
          // Remove user from match data
          removeUserFromMatchData(uDetails?.userId);

          await webServices.userLike({ userId: uDetails?.userId, action: 'dislike' });
        } else {
          setUserData({});
        }
      } else if (resp.data === 'showDailyLikeRemainder') {
        setDailyLikeRemainder(true);
      } else if (resp.data === 'noActivePlan') {
        setShowActivePlan(true);
      }
    }
  };

  const handleSendRose = async () => {
    const resp = await authCall('user/userCheckPermission', { action: 'rose' });
    if (resp.data === 'profileNotApproved') {
      history.push(AppConstants.routes.congratulations);
    } else if (resp.data === 'profileNotComplete') {
      setSection2RemainderMsg(true);
    } else if (resp.data === 'showDailyLikeRemainder') {
      setDailyLikeRemainder(true);
    } else if (resp.data === 'showRosePurchase') {
      setShowRoseSend(true);
    } else if (resp.data === 'noActivePlan') {
      setShowActivePlan(true);
    } else {
      setShowRoseSend(true);
    }
  };

  const handleConfirmRoseSend = async (response) => {
    if (response.roses) {
      const { data, success } = await webServices.getMyRoses();
      if ((success && data.my_roses < 1) || data.my_roses < response.roses) {
        setShowRoseSend(false);
        setRoseExceed(true);
        setRoseCountSend(response.roses);
        setMyTotalRoses(data.my_roses);
      } else {
        const uDetails = matchData[matchCount];

        if (uDetails?.userId) {
          const apiResponse = await webServices.userLike({
            userId: uDetails.userId,
            action: 'rose',
            roses: response.roses
          });
          if (apiResponse?.data?.showFirstMatchPopup === true) {
            setIsOpenFirstMatchPopup(true);
          }
        } else {
          setUserData({});
        }

        setRoseSent(true);
        dispatch(getUserPlansDetails());
      }
    }
  };

  useEffect(async () => {
    if (location.hash !== '#0') {
      uidParamRef.current = { uid: null, isLoaded: false };
      const uid = Number.isNaN(+decodeData(query.get("uid"))) ? null : decodeData(query.get("uid"));
      if (uid) {
        uidParamRef.current.uid = uid;
      }

      dispatch(pageTitle('Match Queue'));
      setUserListingView('grid-view');
      getMataches();
      // getMatchCount();
      const resp = await webServices.getUserDetail();
      if (resp && resp.success === true) {
        dispatch(setUser(resp.data));
      }
    }
  }, [location.search]);

  useEffect(() => {
    dispatch(getUserPlansDetails());
    setBonusMsg(planDetails.isReadBonusMsg);

    if (current.plan_subscription_id === null && current.status === 'ACTIVE') {
      setPlanExpireRemainder(planDetails.isReadPlanRemainderMsg);
    }
  }, [
    dispatch,
    planDetails.isShowTrial,
    planDetails.isReadBonusMsg,
    planDetails.isReadPlanRemainderMsg
  ]);

  const handleClickProfile = (val) => {
    history.push({
      pathname: AppConstants.routes.publicProfile,
      state: { occordian: val }
    });
  };

  const filterBtnClickHandler = async (formData) => {
    setLoader(true);
    setIsSpinner(true);

    const result = await authCall(`user/match-queue-listing${location.search}`, formData);
    if (result && result.success === true) {
      setMatchData(result.data);
      setUserData(result.data[0]);

      setTimeout(() => {
        setLoader(false);
        setIsSpinner(false);
      }, 1000);
    }
  };

  const toggleFilterPopupVisibility = isVisible => {
    if (current?.status !== 'ACTIVE') {
      history.push(AppConstants.routes.congratulations);
    } else {
      setIsFilterPopupVisible(isVisible);
    }
  };

  const filterBtnHandler = (formData, closeFilter = false) => {
    if (closeFilter) {
      toggleFilterPopupVisibility(false);
    }

    filterBtnClickHandler(formData);
  };

  const resetFilterHandler = async () => {
    const resp = await authCall(`user/match-queue/filter/reset`, matchFilterPreferences);
    if (resp && resp.success === true) {
      dispatch(setUser({
        ...structuredClone(current),
        match_preferences: matchFilterPreferences
      }));
      filterBtnClickHandler(matchFilterPreferences);
    }
  };

  return (
    <>
      <section className={`inner-wrapper-newdesign mobilematchQue ${matchData.length > 0 || isSpinner ? '' : `matchNotFound ${current.looking_for === 'WOMAN' ? 'womanFound' : 'manFound'}`}`}>
        <div className="row">
          <div className="col-md-12 ">
            <div className={isSpinner ? 'row spinner-row' : 'largeScreen'}>
              <>
                {/* eslint-disable-next-line no-nested-ternary */}
                {isSpinner
                  ? <Spinner active={isSpinner} />
                  : (matchData.length > 0
                    ? <ProfileBox
                      dispatch={dispatch}
                      history={history}
                      pageQueryParam={pageQueryParam}
                      data={userData}
                      matchData={matchData}
                      loader={loader}
                      handleLike={handleLike}
                      handleDislike={handleDislike}
                      handleSendRose={handleSendRose}
                      matchCount={myMatchedCount}
                      current={current}
                      planDetails={planDetails}
                      isUserPlanExpired={isUserPlanExpired}
                      setMatchProfile={setMatchProfile}
                      userListingView={userListingView}
                      setUserListingView={setUserListingView}
                      filterBtnClickHandler={filterBtnClickHandler}
                      handleClickProfile={handleClickProfile}
                      handleOpenInactivePlanPopup={handleShowActivePlan}
                      toggleFilterPopupVisibility={toggleFilterPopupVisibility}
                      resetFilterHandler={resetFilterHandler}
                      checkIfFilterApplied={checkIfMatchQueueFilterApplied}
                    />
                    : <NoMatchQueueDataComponent
                      toggleFilterPopupVisibility={toggleFilterPopupVisibility}
                      resetFilterHandler={resetFilterHandler}
                      handleClickProfile={handleClickProfile}
                    />
                  )}
              </>
            </div>
          </div>
        </div>
      </section>

      {isFilterPopupVisible && (<MatchQueueFilterComponent
        loggedInUser={current}
        cancelBtnHandler={() => toggleFilterPopupVisibility(false)}
        filterBtnHandler={filterBtnHandler}
      />)}

      <NoActivePlanPopup
        modalStatus={showActivePlan}
        handleClose={handleCloseActivePlan}
      // currentPlan={planDetails}
      // userDetails={current}
      />

      <Section2remainderPopup
        modalStatus={section2RemainderMsg}
        handleClose={handleCloseSection2Remainder}
        userDetails={current}
      />

      {!isSpinner && (
        <WelcomePopup
          modalStatus={bonusMsg}
          handleClose={handleCloseBounsMsg}
          userDetails={current}
        />
      )}

      <PlanExpireRemainderPopup
        modalStatus={planExpireRemainder}
        currentPlan={planDetails}
        userDetails={current}
        handleClose={handleClosePlanRemainder}
      />

      <HoldMatchPopup
        modalStatus={planDetails.isHoldMatches === '1' && isOpenHoldMatch}
        handleClose={handleCloseBounsMsg}
        handleCloseHoldMatch={handleCloseHoldMatch}
        userDetails={current}
      />

      <RoseSendPopup
        modalStatus={showRoseSend}
        handleClose={handleCloseRoseSend}
        userData={userData}
        handleConfirmRoseSend={handleConfirmRoseSend}
        roseSent={roseSent}
        handleCloseCancel={handleCloseCancel}
      />

      <DailyLikeRemainderPopup
        modalStatus={dailyLikeRemainder}
        currentPlan={planDetails}
        userDetails={current}
        handleClose={handleCloseDailyLikeRemainder}
      />

      <RoseExceedPopup
        modalStatus={roseExceed}
        userData={userData}
        // userDetails={current}
        roseCountSend={roseCountSend}
        myTotalRoses={myTotalRoses}
        handleClose={handleCloseRoseExceed}
      />

      <DailyLikeRemainderForRosePopup
        modalStatus={dailyLikeRemainderRose}
        currentPlan={planDetails}
        userDetails={current}
        handleClose={handleCloseDailyLikeRemainderRose}
      />

      <FirstMatchPopup
        modalStatus={isOpenFirstMatchPopup}
        handleClose={handleFirstMatchPopupCloseBtn}
        userDetails={current}
      />
    </>
  );
};

export default MatchesPage;
